import React from 'react';
import { Row, Col, Space, Button } from 'antd';
import { HeaderDataSource } from './data';

export default function Header(props) {

  const { isMobile } = props;
  return (
    <header {...props}>
      <Row className="nav" justify="space-between">
        <Col span={isMobile?24:6}>
          <img src={HeaderDataSource.logo.src} alt="apexDB logo" className="nav-logo-img" />
          <span className="nav-logo-title">{HeaderDataSource.logo.title}</span>
        </Col>
        {!isMobile && <><Col span={14}>
          <Space size={40}>
            {
              HeaderDataSource.menu.map((item, i) => (<a href={item.href} className='nav-menu-item'>{item.title}</a>))
            }
          </Space>

        </Col>
          <Col span={4} >
            <Button type="primary" className="nav-btn" target='_blank' href='https://www.xiaodun.com/register'>立即申请</Button>
          </Col>
        </>}

      </Row>

    </header>
  );
}
